
export const getUrl = (endpoint) => {
    // https://assignment-11-server-pujadey48.vercel.app
    // return `http://localhost:5000${endpoint}`;
    return `https://assignment-11-server-pujadey48.vercel.app${endpoint}`;
} 